export const CURRENT_LIBRARIES = [
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Odilia Camacho Gómez"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Municipal De Paz De Rio"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Municipal Tiberio Vanegas Pinzón"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Municipal De Tota"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Municipal José Olimpo Álvarez Sánchez"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Municipal de Facatativá"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Municipal Ricardo Moros Urbina"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Municipal Henry Moreno Guevara"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Del Corregimiento De Santandercito"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Municipal De Simijaca"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Huila",
    "libraryName": "Biblioteca Pública del Municipio de Algeciras Jorge Humberto Trujillo"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Norte de Santander",
    "libraryName": "Biblioteca Pública Municipal José Ignacio Rangel Rojas"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Santander",
    "libraryName": "Biblioteca Pública Municipal De Galán"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Popular Lisímaco Suárez Reyes"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Isolda Echavarría"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Publica Jesús Antonio Valle"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Caldas",
    "libraryName": "Biblioteca Pública Juan De Dios Aranzazu"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Caldas",
    "libraryName": "Biblioteca Pública Municipal De La Dorada"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Caldas",
    "libraryName": "Biblioteca Pública Satélite La Enea"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Quindío",
    "libraryName": "Biblioteca Pública Municipal de Armenia Carmelina Soto Valencia"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Quindío",
    "libraryName": "Biblioteca Pública Juan Bautista Arboleda"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region2",
    "Región": "Andina Occidental",
    "Departamento": "Risaralda",
    "libraryName": "Biblioteca Pública Municipal José Eusebio Caro"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region3",
    "Región": "Caribe Norte",
    "Departamento": "Atlántico",
    "libraryName": "Biblioteca Municipal Campo De La Cruz"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region3",
    "Región": "Caribe Norte",
    "Departamento": "Cesar",
    "libraryName": "Biblioteca Pública Municipal de San Diego Marta Lucia Guerra"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region3",
    "Región": "Caribe Norte",
    "Departamento": "Magdalena",
    "libraryName": "Biblioteca Pública Municipal Gabriel García Márquez"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region3",
    "Región": "Caribe Norte",
    "Departamento": "Magdalena",
    "libraryName": "Biblioteca Pública Orlando Salgado Parody"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Bolívar",
    "libraryName": "Biblioteca Distrital Jorge Artel"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Bolívar",
    "libraryName": "Biblioteca Pública Municipal Mariano Abel Guerrero Romero"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Bolívar",
    "libraryName": "Biblioteca Pública Vicente Guaitero"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Córdoba",
    "libraryName": "Biblioteca Pública Municipal Luís Felipe Pineda"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Córdoba",
    "libraryName": "Biblioteca Pública Municipal Momil"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Córdoba",
    "libraryName": "Biblioteca Pública Municipal Petronio Rentería Mosquera"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region4",
    "Región": "Caribe Sur",
    "Departamento": "Córdoba",
    "libraryName": "Biblioteca Pública Municipal Manuel Francisco Banqueth Vaquero \"El Indio Banqueth"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region5",
    "Región": "Oriente",
    "Departamento": "Casanare",
    "libraryName": "Biblioteca Pública Municipal de Villanueva Casanare"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region5",
    "Región": "Oriente",
    "Departamento": "Guaviare",
    "libraryName": "Biblioteca Pública Departamental Y Patrimonial Del Guaviare"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region5",
    "Región": "Oriente",
    "Departamento": "Meta",
    "libraryName": "Ecobiblioteca Biblioteca Pública Municipal Castilla La Nueva"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region5",
    "Región": "Oriente",
    "Departamento": "Meta",
    "libraryName": "Biblioteca Pública Municipal Ernesto María Peña Romero"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region5",
    "Región": "Oriente",
    "Departamento": "Vichada",
    "libraryName": "Biblioteca Pública Municipal de Santa Rosalía"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Cauca",
    "libraryName": "Biblioteca Pública Municipal de Buenos Aires Gabriel García Márquez"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Cauca",
    "libraryName": "Biblioteca Resguardo Indígena Puracé Anatolio Quirá"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Cauca",
    "libraryName": "Biblioteca Pública Municipal Gabriel García Márquez"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Valle del Cauca",
    "libraryName": "Biblioteca Pública Municipal Simón Bolívar"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Valle del Cauca",
    "libraryName": "Biblioteca Pública Municipal de Bugalagrande"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Valle del Cauca",
    "libraryName": "Biblioteca Pública Municipal de Dagua Miguel Ángel Jaramillo"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region6",
    "Región": "Pacífico",
    "Departamento": "Valle del Cauca",
    "libraryName": "Biblioteca Pública Municipal Duvardo Piedrahita Cardona"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal Barbacoas Lee"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Monseñor Remigio Narváez Benavides"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Milciades Chaves Chamorro"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal de Los Barrios Surorientales de Comfamiliar De Nariño"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal De Ricaurte"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal Monseñor José Antonio Bolaños"
  },
  {
    "Grupo": "grupo1",
    "regionId": "g1_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal de Sapuyes"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Municipal Liberar Arcabuco"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Municipal Jairo Elberto González Castillo"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Boyacá",
    "libraryName": "Biblioteca Pública Manuel María Franco"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública de Anolaima"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Municipal del Municipio de La Palma"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Cundinamarca",
    "libraryName": "Biblioteca Pública Municipal La Quinta De Samper"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Huila",
    "libraryName": "Biblioteca Pública Municipal Antonio Palomar Avilés"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Huila",
    "libraryName": "Biblioteca Pública Municipal De Garzón Luis Calixto Leiva Charry"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Norte de Santander",
    "libraryName": "Biblioteca Pública Municipal Manuel Guillermo Giraldo"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Norte de Santander",
    "libraryName": "Biblioteca Pública Municipal Francisco Arévalo Claro"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Santander",
    "libraryName": "Biblioteca Pública Municipal Antonia Santos Plata"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Santander",
    "libraryName": "Biblioteca Pública José Antonio Galán"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Santander",
    "libraryName": "Biblioteca Pública Municipal Fuente del Saber"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Santander",
    "libraryName": "Biblioteca Pública Epifanio Blanco Peña"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Pública Soledad Rengifo"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Casa de la Cultura El Salado"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Pública Municipal Francisco Antonio Moreno y Escandón"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Municipal del municipio de Saldaña"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Pública Municipal Germán Guzmán Campos"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region1",
    "Región": "Andina Centroriental",
    "Departamento": "Tolima",
    "libraryName": "Biblioteca Pública Municipal De Villarrica Tolima"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Municipal Gonzalo Arango Arias"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Municipal Francisco José De Caldas"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Municipal Francisco Duque Betancur"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Municipal Jesús Antonio Arango Gallo"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Municipal Eulises Rivera"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Publica Doradal Puerto Triunfo"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Marco Tulio Torres"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Municipal Arturo Vargas Medina"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Antioquia",
    "libraryName": "Biblioteca Pública Presbítero Jesús Emilio Ramírez."
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Caldas",
    "libraryName": "Biblioteca Pública Municipal De Chinchiná"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Caldas",
    "libraryName": "Biblioteca Pública Municipal Joaquín Ospina Vallejo"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Caldas",
    "libraryName": "Biblioteca Pública Municipal Octavio Hernández Jiménez"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Risaralda",
    "libraryName": "Biblioteca Pública Municipal José Guillermo Álzate Fernández"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region2",
    "Región": "Andina Occidental",
    "Departamento": "Risaralda",
    "libraryName": "Biblioteca Pública Municipal León De Greiff"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region3",
    "Región": "Caribe Norte",
    "Departamento": "Cesar",
    "libraryName": "Biblioteca Pública Municipal de La Gloria"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region3",
    "Región": "Caribe Norte",
    "Departamento": "Magdalena",
    "libraryName": "Biblioteca Pública Municipal De Santa Ana Magdalena"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region4",
    "Región": "Caribe Sur",
    "Departamento": "Bolívar",
    "libraryName": "Mega Biblioteca Juan José Nieto De Rosedal"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region4",
    "Región": "Caribe Sur",
    "Departamento": "Bolívar",
    "libraryName": "Biblioteca Pública Municipal de Simití"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region4",
    "Región": "Caribe Sur",
    "Departamento": "Bolívar",
    "libraryName": "Biblioteca Pública Walberto Ordoñez Hernández"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region4",
    "Región": "Caribe Sur",
    "Departamento": "Córdoba",
    "libraryName": "Biblioteca Pública Municipal Pedro Regalado Barrios Diaz"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region5",
    "Región": "Oriente",
    "Departamento": "Casanare",
    "libraryName": "Biblioteca Pública Municipal José Eustasio Rivera"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region5",
    "Región": "Oriente",
    "Departamento": "Meta",
    "libraryName": "Biblioteca Pública Municipal De Mapiripán"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region5",
    "Región": "Oriente",
    "Departamento": "Meta",
    "libraryName": "Biblioteca Pública Municipal Reinerio Arenas"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region5",
    "Región": "Oriente",
    "Departamento": "Vichada",
    "libraryName": "Biblioteca Departamental Manuel María Villalba Velásquez"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region6",
    "Región": "Pacífico",
    "Departamento": "Cauca",
    "libraryName": "Biblioteca Pública Gobierno Del Japón"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region6",
    "Región": "Pacífico",
    "Departamento": "Cauca",
    "libraryName": "Biblioteca Pública Municipal de Florencia Cauca"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region6",
    "Región": "Pacífico",
    "Departamento": "Cauca",
    "libraryName": "Biblioteca Pública Municipal De Sotará"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region6",
    "Región": "Pacífico",
    "Departamento": "Chocó",
    "libraryName": "Biblioteca Pública Departamental Arnoldo de los Santos Palacios Mosquera"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal Páginas para la Convivencia y la Paz"
  },
  {
    "Grupo": "grupo2",
    "regionId": "g2_region7",
    "Región": "Sur",
    "Departamento": "Nariño",
    "libraryName": "Biblioteca Pública Municipal De Olaya Herrera"
  }
]